<template>
  <GtcModal
    :open="open"
    center
    :title="title"
    width="480px"
    :show-cancel-button="false"
    @ok="handleOk"
    @cancel="handleOk"
  >
    <div class="w-full my-6 gap-4 ink-16 text-ink-950 whitespace-pre-line">
      <span>{{ message }}</span>
    </div>
  </GtcModal>
</template>

<script setup lang="ts">
import GtcModal from '@/components/gtc-modal/GtcModal.vue'

interface Props {
  title: string
  message: string
  modalId?: string
  open?: boolean
}

interface EmitData {
  ok: boolean
}

const props = withDefaults(defineProps<Props>(), {
  open: true,
})

const emit = defineEmits<{
  cancel: []
  confirm: [data: EmitData]
  'update:open': [value: boolean]
}>()

const handleOk = () => {
  emit('confirm', { ok: true })
}
</script>
